import { render, staticRenderFns } from "./nav-left.vue?vue&type=template&id=4900edfe&scoped=true"
import script from "./nav-left.vue?vue&type=script&lang=ts"
export * from "./nav-left.vue?vue&type=script&lang=ts"
import style0 from "./nav-left.vue?vue&type=style&index=0&id=4900edfe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4900edfe",
  null
  
)

export default component.exports